import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import defineAbilities from './ability'

Vue.use(abilitiesPlugin, defineAbilities())